/**
 * Match de itens tb_sca_menu.ds_route (path + query opcional, ex. ?nature=OWN).
 */

/** Rotas legadas equivalentes (menu vs URL canónica após rename). */
const PATH_ALIASES = {
  "/cad/configuracao-repositorios": "/cad/configuracao-repositorio",
  "/cad/configuracao-repositorio": "/cad/configuracao-repositorio",
  "/cad/repositorio": "/cad/configuracao-repositorio",
};

function canonicalNavPath(pathname) {
  const p = String(pathname || "").trim();
  if (!p) return "";
  return PATH_ALIASES[p] || p;
}

export function parseNavRoute(dsRoute) {
  const raw = String(dsRoute || "").trim();
  if (!raw) return { pathname: "", search: "", params: new URLSearchParams() };
  const qIdx = raw.indexOf("?");
  const pathname = qIdx >= 0 ? raw.slice(0, qIdx) : raw;
  const search = qIdx >= 0 ? raw.slice(qIdx) : "";
  const params = new URLSearchParams(
    search.startsWith("?") ? search.slice(1) : search
  );
  return { pathname, search, params };
}

/**
 * @param {string} dsRoute
 * @param {string} appPathname path sem alias (ex. /gsf/extratos-proprietario)
 * @param {string} [locationSearch] location.search (?nature=OWN)
 */
export function navRouteMatches(dsRoute, appPathname, locationSearch = "") {
  const route = parseNavRoute(dsRoute);
  if (!route.pathname) return false;
  const path = canonicalNavPath(appPathname);
  const routePath = canonicalNavPath(route.pathname);
  const pathOk =
    path === routePath || path.startsWith(`${routePath}/`);
  if (!pathOk) return false;

  const requiredNature = route.params.get("nature");
  if (requiredNature) {
    const loc = new URLSearchParams(
      String(locationSearch || "").replace(/^\?/, "")
    );
    return (
      String(loc.get("nature") || "").toUpperCase() ===
      String(requiredNature).toUpperCase()
    );
  }
  return true;
}

/**
 * Melhor item de menu para pathname (+ search). Preferência: path mais longo,
 * depois rotas com query (mais específicas).
 */
export function scoreNavRouteMatch(dsRoute) {
  const route = parseNavRoute(dsRoute);
  const natureBoost = route.params.has("nature") ? 100 : 0;
  return route.pathname.length * 1000 + natureBoost + route.search.length;
}
